// Match scoring — kept pure and in one place so the weights are easy to read
// and test. Score is 0–100:
//   • subject complementarity   ≤ 35   (teach + learn pairs × 10)
//   • availability overlap      ≤ 50   (shared 2-hour slots × 4)
//   • shared language           + 15   (flat, see below)
// Language is a bonus, never a filter, and never negative — it surfaces
// same-language partners first without hiding anyone.

export const NEUTRAL_LANGUAGE = 'English';

// Languages both profiles list. A missing/empty list is treated as [English]
// so pre-language profiles still match and are never penalised.
export const sharedLanguages = (a, b) => {
  const la = a && a.length ? a : [NEUTRAL_LANGUAGE];
  const lb = b && b.length ? b : [NEUTRAL_LANGUAGE];
  return la.filter((l) => lb.includes(l));
};

// One shared non-English language is enough to study together; more doesn't
// help further, so the bonus is flat rather than per-language.
export const languageBonus = (sharedLangs) =>
  (sharedLangs || []).some((l) => l !== NEUTRAL_LANGUAGE) ? 15 : 0;

export const matchScore = ({ teachLearnPairs = 0, commonSlots = 0, sharedLangs = [] }) => {
  let s = 0;
  s += Math.min(teachLearnPairs * 10, 35);
  s += Math.min(commonSlots * 4, 50);
  s += languageBonus(sharedLangs);
  return Math.min(s, 100);
};
